<script setup lang="ts">
import { computed, inject } from 'vue'
import type { JavaScriptServiceModel } from '@/types'
import type { ScopeDescriptor } from '@/types/bbel-types'
import AdvancedSettings from './AdvancedSettings.vue'
import BbelField from '@/views/builder/components/bbel/BbelField.vue'
import { BBEL_SCOPE_KEY, EMPTY_BBEL_SCOPE, type BbelScopeContext } from '@/views/builder/composables/bbel-context'

const props = defineProps<{
  modelValue: JavaScriptServiceModel
}>()

const emit = defineEmits<{
  'update:modelValue': [value: JavaScriptServiceModel]
}>()

// Scope is provided by BuilderView; empty in read-only hosts (highlighting only, no suggestions).
const bbelScopeCtx = inject<BbelScopeContext | undefined>(BBEL_SCOPE_KEY, undefined)
const scope = computed<ScopeDescriptor>(() => bbelScopeCtx?.value ?? EMPTY_BBEL_SCOPE)

const code = computed({
  get: () => props.modelValue.javaScript ?? '',
  set: (value: string) => emit('update:modelValue', { ...props.modelValue, javaScript: value }),
})
</script>

<template>
  <div class="mb-3">
    <label class="form-label">JavaScript Code</label>
    <BbelField
      v-model="code"
      :scope="scope"
      lang="javascript"
      field-shape="body"
      placeholder="// JavaScript — use {{ }} for dynamic values"
    />
    <div class="form-text">
      Transform data with JavaScript. Type for language autocomplete; use
      <code v-pre>{{ }}</code> to insert values from upstream services, connections, or config.
    </div>
    <AdvancedSettings />
  </div>
</template>
